var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",staticStyle:{"margin-bottom":"5px"}},[_c('lot-header',{attrs:{"bid":_vm.bid}}),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"padding":"5px !important"}},[_c('lot-content',{attrs:{"bid":_vm.bid}})],1),_vm._v(" "),(_vm.isActive)?_c('bid-modal',{attrs:{"bid":_vm.bid}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f64af0fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card/LotLayout.vue
// module id = null
// module chunks = 